// Mobile menu toggle functionality
document.addEventListener("DOMContentLoaded", function () {
  // Initially hide all lists in mobile view
  if (window.innerWidth <= 768) {
    document.querySelectorAll(".nav-column ul").forEach((ul) => {
      ul.style.display = "none";
    });
  }

  // Make entire nav column clickable for accordion
  const navColumns = document.querySelectorAll(".nav-column");
  navColumns.forEach((column) => {
    column.addEventListener("click", function (e) {
      // Only react to clicks in mobile view
      if (window.innerWidth <= 768) {
        const control = this.querySelector(".mobile-menu-control");
        const navList = this.querySelector("ul");

        if (navList.style.display === "block") {
          navList.style.display = "none";
          control.textContent = "+";
        } else {
          navList.style.display = "block";
          control.textContent = "-";
        }
      }
    });

    // Prevent clicks on the list items from triggering the accordion
    const navList = column.querySelector("ul");
    if (navList) {
      navList.addEventListener("click", function (e) {
        e.stopPropagation();
      });
    }
  });

  // Adjust display on window resize
  window.addEventListener("resize", function () {
    const navLists = document.querySelectorAll(".nav-column ul");

    if (window.innerWidth <= 768) {
      // Reset all to collapsed state on mobile
      navLists.forEach((list) => {
        list.style.display = "none";
      });
      document.querySelectorAll(".mobile-menu-control").forEach((control) => {
        control.textContent = "+";
      });
    } else {
      // Always show lists on desktop
      navLists.forEach((list) => {
        list.style.display = "block";
      });
    }
  });
});
